import $ from "jquery";
import Store_Variable from "@bd-components/store-variable";
import BD_Timer from "@bd-components/bd-timer";
import Store_SequenceHistory from "@bd-components/store-sequence-history";
import BD_Block from "@bd-core/bd-block";
import BD_GAME_LOGIC from "@bd-core/game-logic";
import { compile } from "@bd-utils/handlerbars-helper";
import { createQuestion } from "@bd-utils/question";
import CONFIG from "@bd-core/config";

export class Block_Audio extends BD_Block {
  constructor() {
    super();

    this.type = "audio";
    this.templateID = "audio-template";

    this.elms = {
      playBtn: ".js-play",
      pauseBtn: ".js-pause",
      questionCard: ".questionCard",
      answer: ".js-answer",
      submit: ".js-submit",
      skip: ".js-skip",
      backWrapper: ".questionCard__back",
      back: ".js-back",
      questionCardV2: "v2-questionCard",
    };

    this._events = this.getEvents();

    /* custom attributes */
    /**
     * @type {HTMLAudioElement}
     */
    this.audio = null;
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "click",
        selector: elms.playBtn,
        handler: this.onPlayAudio,
      },
      {
        event: "click",
        selector: elms.pauseBtn,
        handler: this.onPauseAudio,
      },
      {
        event: "click",
        selector: elms.skip,
        handler: this.onPauseAudio,
      },
      {
        event: "click",
        selector: elms.skip,
        handler: this.onSkip,
      },
      {
        event: "click",
        selector: elms.submit,
        handler: this.submit,
      },
      {
        event: "click",
        selector: elms.back,
        handler: this.back,
      },
    ];
  }

  beforeInit() {
    this.render();
    this.registerAudio();
    this.setGameState();
    this.setQuestion();
    this.setTimer();

    if (this._data.direct_play_on_question && this.audio) {
      this.onEnded(this);
    }
  }

  render() {
    const htmlTemplate = $("#" + this.templateID).html();
    const html = compile(htmlTemplate, this._data);
    $("#templateWrapper").html(html);
  }

  registerAudio() {
    const _this = this;

    const audioFromVariable = Store_Variable.getAudioFromVariable(this._data);
    const audio = audioFromVariable || this._data.audio;

    if (audio) {
      this.audio = new Audio(audio);

      this.audio.addEventListener("ended", () => this.onEnded(_this));

      this.onPlayAudio();
    }
  }

  onEnded(ctx) {
    const disableReplay =
      CONFIG.game_options.building_block?.audio?.audio_disable_replay || false;
    const $questionCard = $(ctx.elms.questionCard);
    const $questionCardV2 = $(ctx.elms.questionCardV2);

    if (!ctx._data.has_question) {
      BD_GAME_LOGIC.goToDefaultNextBlock();
      return false;
    }

    this.timer.start();
    $questionCard.removeClass("audioPlaying").addClass("is-opened");

    if (disableReplay) {
      const $playBtn = $(this.elms.playBtn);
      const $audioPlayer = $playBtn.parent();

      $playBtn.prop("disabled", true).css("opacity", 0);
      $audioPlayer
        .css({ padding: 0, background: "none" })
        .find(".audioPlayer__bg")
        .css({ transform: "translateY(-20px)" });
    }

    if ($questionCardV2) {
      $(".question-modal")
        .css({ background: "#fff" })
        .addClass("is-load-question");
    }
    ctx.question.showSubmitBtn(ctx);
  }

  setGameState() {
    const showBackBtn = () => {
      if (Store_SequenceHistory.data) {
        $(this.elms.backWrapper).addClass("is-active");
      }
    };

    showBackBtn();
  }

  setQuestion() {
    this.question = createQuestion(this._data.question);
    this._events = [...this._events, ...this.question.getEvents()];
  }

  setTimer() {
    this.timer = new BD_Timer(this._data, this.question);
  }

  /* ========= ELEMENT FUNCTION HANDLER ===============*/
  onPlayAudio(e) {
    if (e) e.preventDefault();

    const $questionCard = $(this.elms.questionCard);

    if (!this.audio) {
      $questionCard.addClass("is-opened");
      this.timer.start();
      return true;
    }

    if (this.audio.paused) {
      var startPlayPromise = this.audio.play();

      if (startPlayPromise !== undefined) {
        startPlayPromise
          .then(() => {
            // Start whatever you need to do only after playback
            // has begun.
            $questionCard.addClass("audioPlaying");
          })
          .catch((error) => {
            console.warn("Unable to start auto play", error);

            if (error.name === "NotAllowedError") {
              //Show play button here
            } else {
              // Handle a load or playback error
            }
          });
      }
    }
  }

  onPauseAudio(e) {
    if (e) e.preventDefault();

    if (!this.audio) return true;

    const $questionCard = $(this.elms.questionCard);

    if (!this.audio.paused) {
      try {
        this.audio.pause();
        $questionCard.removeClass("audioPlaying");
      } catch (error) {
        console.warn("Can't pause audio. Reason:", error);
      }

      return;
    }
  }

  onSkip() {
    const _this = this;
    this.onEnded(_this);
  }

  back() {
    const seqHistory = Store_SequenceHistory.data;
    // @ts-ignore
    const currentBlockID = parseInt(BD_GAME_LOGIC.getCurrentBlockID());
    const history = seqHistory[currentBlockID];
    if (!history) return;

    BD_GAME_LOGIC.goBack(history.prev);
  }

  submit(e, $el) {
    this.question.submitAnswer($el, this);
  }

  afterDestroy() {
    this.timer.stop();
    if (this.audio && !this.audio.paused) {
      try {
        this.audio.pause();
        this.audio = null;
      } catch (error) {
        console.warn("Can't pause audio. Reason:", error);
      }
      return;
    }
  }
}
